import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DownloadFileService {
  public downloadUrlObjectFile(
    url: string,
    fileName: string
  ): Observable<null> {
    fetch(url).then(res => res.blob()).then(blob => {
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      URL.revokeObjectURL(link.href);
    }).catch(error => console.error('Download failed:', error));
    return of(null);
  }
}
